import React from "react";

import EndcustomersComboBox from "Components/Endcustomer/EndcustomersComboBox";

// MUI
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FilesCombobox from "Components/Files/FilesCombobox";
import PriceField from "Components/UI/Form/PriceField";
import {
  Collapse,
  Divider,
  FormControlLabel,
  InputAdornment,
  Switch,
  Typography,
} from "@mui/material";
import SelectWithClear from "Components/UI/Form/SelectWithClear";
import DateWithClear from "Components/UI/Form/DateWithClear";
import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";
import { useAuth } from "Hooks/useAuth";

export default function InvoiceFormGenerally({
  formData,
  FORM_MODE,
  handleInputChange,
  endcustomers,
  currencyCodes,
  files,
  onStopInvoice,
}) {
  const { isAdmin } = useAuth();
  return (
    <>
      <Grid container spacing={2}>
        {FORM_MODE === "CREATE" ? (
          <Grid item container spacing={2}>
            <Grid item>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.Type === "Credit"}
                    onChange={(event) =>
                      handleInputChange(
                        "Type",
                        event.target.checked ? "Credit" : "Invoice"
                      )
                    }
                  />
                }
                label="Kredit"
              />
            </Grid>
          </Grid>
        ) : null}

        <Grid item xs={12} sm={6} md={4} pt="5px">
          <Collapse in={formData.Type === "Credit"}>
            <TextField
              name="InvoiceReference"
              disabled={FORM_MODE === "LOCKED"}
              label="Fakturareferens"
              value={formData.InvoiceReference}
              onChange={(e) =>
                handleInputChange("InvoiceReference", e.target.value)
              }
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Collapse>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="ExternalInvoiceNo"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(e) =>
                handleInputChange("ExternalInvoiceNo", e.target.value)
              }
              label="Extern Fakturanr"
              value={formData.ExternalInvoiceNo}
              size="small"
              color="primary"
              fullWidth
              margin="dense"
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <PriceField
              name="Price"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(newVal) => handleInputChange("Price", newVal)}
              label="Belopp"
              value={formData.Price === null ? 0 : formData.Price}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {formData.CurrencyCode}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <EndcustomersComboBox
              disabled={
                FORM_MODE === "LOCKED" || FORM_MODE === "ENDCUSTOMER_CREATE"
                  ? true
                  : false
              }
              label={"Slutkund"}
              autoFocus={true}
              endcustomers={endcustomers}
              selectedEndcustomerID={
                formData.EndCustomerId ? formData.EndCustomerId : null
              }
              onChange={(newVal) => handleInputChange("EndCustomerId", newVal)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FilesCombobox
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label={"Fil"}
              files={files}
              selectedFileID={formData.FileId ? formData.FileId : null}
              onChange={(newVal) => handleInputChange("FileId", newVal)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="ExternalReference"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(e) =>
                handleInputChange("ExternalReference", e.target.value)
              }
              label="Extern referens"
              value={formData.ExternalReference}
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
        {/* OurReference */}
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="OurReference"
              onChange={(e) =>
                handleInputChange("OurReference", e.target.value)
              }
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label="Vår referens"
              value={formData.OurReference}
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
              <SelectWithClear
                label="Valutakod"
                disabled={FORM_MODE === "LOCKED" ? true : false}
                name="CurrencyCode"
                value={formData.CurrencyCode}
                onChange={(e) =>
                  handleInputChange("CurrencyCode", e.target.value)
                }
              >
                {currencyCodes.map((obj) => (
                  <MenuItem key={obj.Value} value={obj.Value}>
                    {obj.Name}
                  </MenuItem>
                ))}
              </SelectWithClear>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="OCR"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(e) => handleInputChange("OCR", e.target.value)}
              label="OCR"
              value={formData.OCR}
              size="small"
              color="primary"
              fullWidth
              margin="dense"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="ClientName"
              disabled={true}
              label="Klientnamn"
              value={formData.ClientName}
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="ClientNumber"
              disabled={true}
              label="Klientnummer"
              value={formData.ClientNumber}
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="EndCustomerNumber"
              disabled
              onChange={(e) =>
                handleInputChange("EndCustomerNumber", e.target.value)
              }
              label="Slutkundsnummer"
              value={formData.EndCustomerNumber}
              size="small"
              color="primary"
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DateWithClear
              label="Fakturadatum"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              value={dayjs(formData.InvoiceDate)}
              onChange={(newVal) =>
                handleInputChange(
                  "InvoiceDate",
                  dayjs(newVal).format("YYYY-MM-DD")
                )
              }
            />
          </Grid>
        </Grid>
      </Grid>
      {formData.Lines && formData.Lines.length > 0 ? (
        <>
          <Divider sx={{ margin: "20px" }} />
          <TableColumns />
          <Grid item container gap={1}>
            {formData.Lines.map((line) => (
              <TableRow row={line} />
            ))}
          </Grid>
        </>
      ) : null}
      {!isAdmin ? (
        <Grid item container spacing={2} marginTop="10px">
          <Grid item xs={12} sm={6} md={4} textAlign="left">
            <LoadingButton
              variant="contained"
              color="error"
              disabled={formData.SystemStatus !== "1"}
              onClick={() => (onStopInvoice ? onStopInvoice() : null)}
            >
              Stoppa faktura
            </LoadingButton>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
}

const TableColumns = () => {
  return (
    <Grid item container textAlign="left" justifyContent="space-between">
      <Grid item md={1} alignItems={"flex-end"}>
        <Typography>Artikelnr</Typography>
      </Grid>
      <Grid item md={3.5}>
        <Typography>Beskrivning</Typography>
      </Grid>
      <Grid item md={1}>
        <Typography>Antal</Typography>
      </Grid>
      <Grid item md={1}>
        <Typography>Enhet</Typography>
      </Grid>
      <Grid item md={1}>
        <Typography>a-pris</Typography>
      </Grid>
      <Grid item md={1}>
        <Typography>Radbelopp ex.moms</Typography>
      </Grid>
      <Grid item md={1}>
        <Typography>% Moms</Typography>
      </Grid>
      <Grid item md={1}>
        <Typography>Radbelopp inkl.moms</Typography>
      </Grid>
    </Grid>
  );
};

const TableRow = ({ row }) => {
  return (
    <Grid item container justifyContent="space-between">
      <Grid item md={1}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="text"
          value={row.ItemNo}
        />
      </Grid>
      <Grid item md={3.5}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="text"
          value={row.Description}
        />
      </Grid>
      <Grid item md={1}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="number"
          value={row.Quantity}
        />
      </Grid>
      <Grid item md={1}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="text"
          value={row.UnitOfMeasure}
        />
      </Grid>
      <Grid item md={1}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="number"
          value={row.UnitPrice}
        />
      </Grid>
      <Grid item md={1}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="number"
          value={row.LineAmountExclVAT}
        />
      </Grid>
      <Grid item md={1}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="number"
          value={row.VATPct}
        />
      </Grid>
      <Grid item md={1}>
        <TextField
          disabled
          fullWidth
          size="small"
          type="number"
          value={row.LineAmountInclVAT}
        />
      </Grid>
    </Grid>
  );
};
